import {
  Box,
  Button,
  Grid,
  TextField,
  Typography
} from "@mui/material";

import Section from "./components/Section";
import DetailGrid from "./components/DetailGrid";
import { useState, useEffect } from "react";
import { useFetcher } from "react-router-dom";

const getDetailGridProps = ({ placement_ids, placement_ids_updated_at }) => {
  const totalPlacements = placement_ids?.length || 0
  const badgeState = totalPlacements > 0 ? "checked" : "unchecked"

  const props = {
    badgeState,
    columns: [
      { title: "Total Placements", description: totalPlacements },
      { title: "Last Modified", description: placement_ids_updated_at || "-" }
    ]
  }

  return props
}

const DistributorPlacementsForm = ({ distributor, onCancel }) => {
  const fetcher = useFetcher()
  const errors = fetcher.data?.errors || {}
  const handleSubmit = (e) => {
    fetcher.submit(e.currentTarget)
  }

  useEffect(() => {
    if (fetcher.state === "idle" && fetcher.data) {
      const updateFailed = "errors" in fetcher.data

      if (!updateFailed) {
        onCancel()
      }
    }
  }, [fetcher, onCancel])

  return (
    <Grid container item>
      <Grid item xs={12}>
        <fetcher.Form method="post" id="placementsForm">
          <TextField
            name="placement_ids"
            multiline
            fullWidth
            error={"placement_ids" in errors}
            helperText={errors["placement_ids"]}
            defaultValue={distributor?.placement_ids?.join(",") ?? ""}
            minRows={4}
          />
        </fetcher.Form>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            float: "right",
            mt: 2
          }}
        >
          <Button form="placementsForm" variant="contained" size="small" sx={{ mr: 1 }} onClick={handleSubmit}>Save</Button>
          <Button size="small" onClick={onCancel}>Cancel</Button>
        </Box>
      </Grid>
    </Grid>
  );
}

const EditButton = ({ onClick }) => (
  <Button sx={{ alignSelf: "self-end" }} variant="contained" size="small" onClick={onClick}>Edit</Button>
)

const DistributorPlacementTargetingsSection = ({ distributor }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = (event) => setIsEditing((prev) => !prev);

  return (
    <Section title={"Placement Targeting Settings"} actionButton={<EditButton onClick={handleEditClick} />}>
      <Grid container item xs={12}>
        <Grid item xs={12} sx={{ mb: 2.5 }}>
          <Typography variant="subtitle1" color="rgb(0,0,0,0.60)">Eligible Placement IDs</Typography>
        </Grid>
        <Grid item xs={12} sx={{ borderRadius: 2, display: "flex", flexDirection: "row" }}>
          {isEditing ? (
            <DistributorPlacementsForm distributor={distributor} onCancel={handleEditClick} />
          ) : (
            <DetailGrid {...getDetailGridProps(distributor)} />
          )} 
        </Grid>
      </Grid>
    </Section>
  )
}

export default DistributorPlacementTargetingsSection;
